import { render } from "./register.vue?vue&type=template&id=326b81a4&scoped=true&ts=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"

import "./register.vue?vue&type=style&index=0&id=326b81a4&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326b81a4"]])

export default __exports__